//Преобразует время в формате "HH:MM:SS" в минуты
export const timeToMinutes = (timeString) => {
    if (!timeString) return 0;
    const parts = timeString.split(':');
    return parseInt(parts[0]) * 60 + parseInt(parts[1]);
};

//Получает текущее время в минутах
export const getCurrentMinutes = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};

//Рассчитывает процент выполнения задачи
export const calculateProgress = (startTime, endTime) => {
    const currentMinutes = getCurrentMinutes();
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);
    // Если задача ещё не началась
    if (currentMinutes < startMinutes) {
        return 0;
    }
    // Если задача уже закончилась
    if (currentMinutes >= endMinutes) {
        return 100;
    }
    // Задача в процессе - рассчитываем процент
    const totalDuration = endMinutes - startMinutes;
    const elapsed = currentMinutes - startMinutes;
    return (elapsed / totalDuration) * 100;
};

//Определяет статус задачи на основе прогресса
export const getTaskStatus = (progress) => {
    if (progress === 0) return 'not_started';
    if (progress === 100) return 'completed';
    if (progress < 40) return 'progress_low';
    if (progress >= 40 && progress < 80) return 'progress_mid';
    return 'progress_high';
};

//Получает цвета в зависимости от статуса задачи
export const getColorsByStatus = (status) => {
    const colors = {
        not_started: { backgroundColor: '#A6FFA1', svgColor: '#46C73F' },
        progress_low: { backgroundColor: '#A6FFA1', svgColor: '#46C73F' },
        progress_mid: { backgroundColor: '#FFE986', svgColor: '#F3A74F' },
        progress_high: { backgroundColor: '#FFB9B9', svgColor: '#D8221B' },
        completed: { backgroundColor: '#FFB9B9', svgColor: '#D8221B' }
    };

    return colors[status] || colors.not_started;
};


//Основная функция для получения всех данных о задаче
export const getTaskColors = (data) => {
    const progress = calculateProgress(data?.time_start, data?.time_end);
    const status = getTaskStatus(progress);
    const colors = getColorsByStatus(status);

    return {
        progress,
        status,
        ...colors
    };
};


//Форматирует время
export const formatTime = (timeString) => {
    if (!timeString) return "";
    return timeString.substring(0, 5);
};


export const getDisplayName = (data) => {
    return data?.title || data?.goods?.name || "Без названия";
};